<template>
  <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow" :title="$t('core.share_file_or_folder')"
    :default-cancel="false" @close="closeDialog" :width="450">

    <ul class="item-descr-list allow-user-select">

      <li>
        <span class="item-descr-tit">
          <label>{{$t('core.file_name')}}</label>
        </span>
        <span class="item-descr-txt">
          {{$t('core.share_folders_name_params',
              {name: selectedList.map(o=>o && o.name).join(), count: selectedList.length})}}
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>{{$t('cos.permission')}}</label>
        </span>
        <span class="item-descr-txt">
          <div>
            <qc-radio value="r" v-model="permission">
              {{$t('core.share_permission_map.r')}}
            </qc-radio>
            <qc-bubble trigger="hover" :appendToBody="false" v-if="!allowShare">
              <qc-icon type="plaint"></qc-icon>
              <template slot="popup">{{$t('error.curr_region_not_support_rw_Share')}}</template>
            </qc-bubble>
            <qc-radio value="rw" v-model="permission" :disabled="!allowShare">
              {{$t('core.share_permission_map.rw')}}
            </qc-radio>
          </div>
          <div class="mt-10" v-if="permission === 'rw' && enableReplication">
            <div class="form-unit">
              <qc-alert style="word-break: break-all;" type="error">
                {{$t('cos.tips.share_replication')}}
              </qc-alert>
            </div>
          </div>
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>{{$t('core.valid_time')}}</label>
        </span>
        <span class="item-descr-txt">
          <div class="form-unit" :class="{'is-error': durationStatus.isError}">
            <div class="tc-15-input-text-wrap">
              <input class="tc-15-input-text m" v-model="duration" style="width:80px;" @keyup="durationValidate" />
              <select class="tc-15-select m" v-model="unit" style="width:70px;min-width:70px;border-left:0;"
                @change="durationValidate">
                <option v-for="(unitLabel, unitKey) in unitMap" :value="unitKey" :key="unitKey"
                  :selected="unit===unitKey">
                  {{unitLabel}}
                </option>
              </select>
              <div class="form-input-help">{{$t(`cos.validate.${durationStatus.message}`)}}</div>
            </div>
          </div>
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>{{$t('core.extract_code')}}</label>
        </span>
        <span class="item-descr-txt">
          <div>
            <qc-radio value="auto" v-model="type" @input="extractValidate">
              {{$t('core.auto_generate')}}
            </qc-radio>
            <qc-radio value="custom" v-model="type" @input="extractValidate">
              {{$t('core.custom')}}
            </qc-radio>
          </div>
          <div class="mt-10">
            <div class="form-unit" :class="{'is-error':extractStatus.isError}">
              <div class="tc-15-input-text-wrap">
                <qc-input :readonly="type==='auto'" v-model="extractCode" style="width:80px;"
                  @keyup="extractValidate" />
                <div class="form-input-help">{{$t(`cos.validate.${extractStatus.message}`)}}</div>
              </div>
            </div>
          </div>
        </span>
      </li>

    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button :disabled="durationStatus.isError || extractCode.length!==6" type="default" @click="submit"
            :title="$t('core.ok')">
            {{$t('core.ok')}}</qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { guidByNum, getInnerProps } from '@/scripts/tools/utils';
import keyBox from '@/scripts/helper/keyBox';

const unitBase = {
  min: 60,
  h: 60 * 60,
  d: 24 * 60 * 60,
};

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    selectedList: Array,
    enableReplication: Boolean,
    allowShare: Boolean,
  },
  data() {
    return {
      // 复制链接
      type: 'auto',
      duration: 2,
      durationStatus: {
        isError: false,
        message: 'share_valid_time[0]',
      },
      unit: 'h',
      unitMap: {
        min: window.lang.t('core.time_unit.min'),
        h: window.lang.t('core.time_unit.h'),
        d: this.$t('core.time_unit.d'),
      },
      extractEdit: '',
      extractStatus: {
        isError: false,
        message: 'enter_6_extract_code',
      },
      permission: 'r',
      keyType: '',
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    expire() {
      return parseInt(unitBase[this.unit] * this.duration, 10);
    },
    extractCode: {
      get() {
        if (this.type === 'auto') {
          return guidByNum(6);
        }
        return this.extractEdit;
      },
      set(val) {
        this.extractEdit = val;
      },
    },
    isSubUin() {
      const isSubUin = this.$store.userInfo
        && this.$store.userInfo.OwnerUin
        && this.$store.userInfo.Uin
        && this.$store.userInfo.OwnerUin !== this.$store.userInfo.Uin;
      return isSubUin && this.keyType === 'SecretKey';
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      this.keyType = keyBox.getKeyType();
      this.type = 'auto';
      this.duration = this.isSubUin ? 1.5 : 2;
      this.unit = this.isSubUin ? 'd' : 'h';
      this.extractEdit = '';
      this.durationStatus = {
        isError: false,
        message: this.isSubUin ? 'share_valid_time[1]' : 'share_valid_time[0]',
      };
      if (this.keyType !== 'SecretKey') {
        this.durationStatus.message = 'share_valid_time[2]';
        delete this.unitMap.d;
      }
      this.permission = 'r';
    },
    // 复制链接间隔输入校验
    durationValidate() {
      const { duration } = this;
      let isError = false;
      let message = '';
      if (this.isSubUin) {
        message = 'share_valid_time[1]';
      } else if (this.keyType === 'SecretKey') {
        message = 'share_valid_time[0]';
      } else {
        message = 'share_valid_time[2]';
      }

      const expireLimit = this.isSubUin ? 1.5 * unitBase.d : 2 * unitBase.h;
      if (!duration) {
        isError = true;
        message = 'empty_input_content';
      } else if (+duration <= 0 || Number.isNaN(+duration)) {
        isError = true;
        message = 'need_positive_number';
      } else if (!/^(\d+)\.?(\d)?$/.test(duration)) {
        isError = true;
        message = 'only_allow_one_decimal';
      } else if (this.expire > expireLimit) {
        isError = true;
      }
      this.durationStatus = { isError, message };
    },
    // 提取码输入校验
    extractValidate() {
      const { extractCode } = this;
      this.extractStatus.message = 'enter_6_extract_code';
      this.extractStatus.isError = false;
      if (!extractCode) {
        this.extractStatus.message = 'empty_input_content';
      } else if (extractCode.length > 6) {
        this.extractStatus.isError = true;
      }
    },
    submit() {
      this.$emit('submit', {
        DurationSeconds: this.expire,
        extract: this.extractCode,
        permission: this.permission,
      });
    },
    closeDialog() {
      this.innerShow = false;
      this.type = 'custom';
    },
  },
};
</script>
